<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    text?: string
    isRequired?: boolean
  }>(),
  {
    class: undefined,
    text: undefined,
    isRequired: true
  }
)
</script>

<template>
  <span :class="cn('text-xs text-error font-medium', props.class)">
    <span v-if="isRequired">*</span>{{ props.text }}
  </span>
</template>
